export const widgetsbarWidths = {
  expanded: 280,
  collapsed: 0
};

export const widgetsContainerPadding = {
  expanded: 1,
  collapsed: 0
};
